import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    userAgent: PropTypes.string,
  },
  render() {
    let ios = "";
    let android = "";
    if (this.props.userAgent === "ios") {
      ios = (
        <a className="store-badge app-store btn-app-download" href="/apps/ios">
          <img src="https://linkmaker.itunes.apple.com/ja-jp/badge-lrg.svg?releaseDate=2016-04-19&kind=iossoftware&bubble=ios_apps" />
        </a>
      );
    }
    if (this.props.userAgent === "android") {
      android = (
        <a className="store-badge btn-app-download" href="/apps/android">
          <img
            className="width-full"
            alt="つなげーとのアプリをGoogle Play で手に入れよう"
            src="https://play.google.com/intl/en_us/badges/images/generic/ja_badge_web_generic.png"
          />
        </a>
      );
    }

    let storeContainer = "";
    if (this.props.userAgent != "pc") {
      storeContainer = (
        <div
          className="width-full"
          style={{ background: "#fff", padding: "20px 0" }}
        >
          <h3 className="mt0" style={{ textAlign: "center" }}>
            つなげーとのアプリを手に入れよう！
          </h3>
          <div className="store-badge-box mt20">
            {ios}
            {android}
          </div>
        </div>
      );
    }

    return <div>{storeContainer}</div>;
  },
});
